import {focusBlock, getPreciseNodeInCodeWorkSpace} from "../highlight";
import {isDropdownType, onTap} from "../utils";
import event, {EVENTS} from "../../lib/event";
import clickElement from "./click-element";
import formInput from "./form-input";
import {BATCH_TIPS_MODE, GUIDE_MODE} from '../../lib/constant';

export default function createNewMessage({target, name, tips}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    if (mode) {
        if (!tips) tips = `创建一个名为「${name}」的新消息`;
        window.stepsRuntime.insertTips(_index, tips, true);
        if (mode === BATCH_TIPS_MODE) {
            return new Promise(resolve => {
                resolve();
            })
        }
    }

    return new Promise((resolve, reject) => {
        let node = getPreciseNodeInCodeWorkSpace(target);
        const newValueDisplay = '新消息';
        if (!node) {
            reject('target not found: ' + JSON.stringify(target));
            return;
        }
        let argType = node.getAttribute('data-argument-type');
        if (!argType) {
            let argNode;
            for (let i = 0; i < node.childNodes.length; ++i) {
                if (node.childNodes[i].getAttribute('data-argument-type') &&
                    (!node.childNodes[i].getAttribute('data-id') || node.childNodes[i].getAttribute('data-argument-type') === 'variable')) {
                    argNode = node.childNodes[i];
                }
            }
            if (!argNode) {
                reject('target not found: ' + JSON.stringify(target));
                return;
            } else {
                node = argNode;
            }
            argType = node.getAttribute('data-argument-type');
        }
        if (!tips) {
            if (isDropdownType(argType)) {
                tips = `点击这里，选择『${newValueDisplay}』`;
            }
        }
        focusBlock({source: node, tips, reject}, mode, _index);
        if (isDropdownType(argType)) {
            onTap(node, () => {
                const handle = () => {
                    const ops = document.querySelectorAll('.blocklyDropDownDiv .goog-menuitem-content');
                    if (ops === null) {
                        setTimeout(handle, 100);
                    } else {
                        for (let i = 0; i < ops.length; ++i) {
                            if (ops[i].innerText.trim() === newValueDisplay) {
                                let lastTop = ops[i].getBoundingClientRect().top;
                                let inter = setInterval(() => {
                                    if (lastTop == ops[i].getBoundingClientRect().top) {
                                        clearInterval(inter);
                                        focusBlock({source: ops[i].parentElement, reject, zIndex: 2000}, mode, _index);
                                        onTap(ops[i].parentElement, () => {
                                            event.emit(EVENTS.CLEAR_COVER);
                                            setTimeout(()=> {
                                                formInput({
                                                    element: 'input[class^="prompt_variable-name-text-input"]',
                                                    value: name,
                                                    tips: `这里输入新的消息名称『${name}』`
                                                }).then(()=>clickElement({
                                                    element: 'button[class^="prompt_ok-button"]',
                                                    tips: '点击『确定』完成创建'
                                                })).then(()=>{
                                                    resolve(true);
                                                })
                                            }, 500);
                                        })
                                    }
                                    lastTop = ops[i].getBoundingClientRect().top;
                                }, 100)
                                break;
                            }
                        }
                    }
                };
                setTimeout(handle, 100);
            });
        }else {
            reject('argType error');
        }
    });
}
